<template>
  <ui-card class="mb-5">
    <div class="columns" v-if="session.media">
      <div class="column is-narrow">
        <div class="video-frame">
          <img :src="session.media.thumbnail" />
        </div>
      </div>
      <div class="column pt-4">
        <div class="columns is-gapless mb-3">
          <div class="column is-narrow is-size-4"><i class="fad mr-4 fa-clapperboard-play has-text-primary"></i></div>
          <div class="column">
            <h6 class="pt-1">{{ session.title }}</h6>

            <div v-html="session.description" class="is-size-7 mb-4"></div>
            <div class="is-size-7 has-text-grey-dark" v-if="registration.conference.is_show_tracks && session.track"><i class="fad fa-fw fa-code-branch mr-2"></i>{{ session.track.title }}</div>
            <div class="is-size-7 has-text-grey-dark" v-if="session.presenter"><i class="fad fa-fw fa-person-chalkboard mr-2"></i>{{ session.presenter }}</div>
            <div class="is-size-7 has-text-grey-dark" v-if="((session.media.duration/1000) < 3600)"><i class="far fa-clock mr-2"></i>00:{{ (session.media.duration / 1000) | moment("utc", "mm:ss") }}</div>
            <div class="is-size-7 has-text-grey-dark" v-else><i class="fad fa-fw fa-clock mr-2"></i>{{ (session.media.duration / 1000) | moment("utc", "H:mm:ss") }}</div>

            <div class="mt-3 has-text-warning has-text-weight-bold" v-if="!session.is_active"><i class="far fa-clock-rotate-left mr-2" />This On-Demand Content has expired and is no longer available.</div>

            <div class="mt-4" v-if="session.recorded_time">
              <section v-if="session.recorded_minutes < session.max_log_minutes">
                <b-progress class="session-progress mb-1 pb-0" size="is-small" type="is-primary" :value="session.recorded_minutes" :max="session.max_log_minutes"></b-progress>
                <div class="is-size-7 has-text-grey-dark">You have recorded {{ session.recorded_minutes * 60 | moment("utc", "HH:mm") }} of the maximum of {{ session.max_log_minutes * 60 | moment("utc", "HH:mm") }} qualified time. Details on your
                  <router-link :to="{name: 'record-log'}"><i class="fad fa-clipboard-check"></i> Record & Attendance Log</router-link>
                  .
                </div>
              </section>
              <section v-else>
                <div class="is-size-7 has-text-grey-dark"><i class="fad fa-fw fa-check has-text-success mr-2"></i>You have recorded the maximum amount of qualified time for this session. Details on your
                  <router-link :to="{name: 'record-log'}"><i class="fad fa-clipboard-check"></i> Record & Attendance Log</router-link>
                  .
                </div>
              </section>
            </div>
          </div>
        </div>

      </div>
      <div class="column has-text-right is-narrow pl-6">
        <b-button type="is-primary" disabled v-if="registration.is_po_pending || !session.is_active"><i class="fas fa-play mr-2"></i>View Content</b-button>
        <router-link :to="{name: 'on-demand-content', params: {registrationId: registration.id, sessionId: session.id}}" v-else>
          <b-button type="is-primary"><i class="fas fa-play mr-2"></i>View Content</b-button>
        </router-link>
      </div>
    </div>
    <div v-else>
      <h6 class="pt-1">{{ session.title }}</h6>
      <div class="is-size-7 has-text-grey-dark">
        <i class="far fa-exclamation-triangle mr-2 ml-1 has-text-warning"></i>This content has not been properly configured and is currently not available.
      </div>
    </div>

  </ui-card>
</template>

<script>
  import UiCard from "../../../components/UiCard.vue";

  export default {
    name: "OnDemandSession",
    components: { UiCard },
    props: {
      session: {
        type: Object,
        required: true
      },
      registration: {
        type: Object,
        required: true
      }
    }
  };
</script>
